import SettingsService from '@modules/Settings/js/libs/SettingsService';

class SettingsAccountingService extends SettingsService {
	constructor() {
		super('settings_accounting');
	}
}

export default SettingsAccountingService;
